import { render } from "./SamuelGelstonLogo.vue?vue&type=template&id=6714f88f"
import script from "./SamuelGelstonLogo.vue?vue&type=script&lang=js"
export * from "./SamuelGelstonLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__